import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import LegacyForm from "./component";
import {
    fetchBrands,
    fetchModels,
    fetchYears,
    fetchVariants,
    fetchRegistrationState,
    resetSelections,
    updateSelectedBrand,
    updateSelectedModel,
    updateSelectedVariant,
    updateSelectedYear,
    updateSelectedState,
    resetSpecifiedKey,
    makeLead,
    updateLead,
    fetchAllBranchCount
} from "./actions";
import { setMobile } from "../../configuration/actions";

const mapStateToProps = ({
    legacyLeadForm: {
        brands,
        models,
        years,
        variants,
        states,
        isModelsLoading,
        isBrandsLoading,
        isYearLoading,
        isVariantsLoading,
        isStatesLoading,
        selectedBrand,
        selectedModel,
        selectedYear,
        selectedVariant,
        selectedState,
        lastUpdatedBrand,
        lastUpdatedModel,
        lastUpdatedYear,
        lastUpdatedVariant,
        lastUpdatedState,
        token,
        branchCount,
        cityCount
    },
    user: {
        mobile
    }
}) => ({
    brands,
    models,
    years,
    variants,
    states,
    isModelsLoading,
    isBrandsLoading,
    isYearLoading,
    isVariantsLoading,
    isStatesLoading,
    selectedBrand,
    selectedModel,
    selectedYear,
    selectedVariant,
    selectedState,
    lastUpdatedBrand,
    lastUpdatedModel,
    lastUpdatedYear,
    lastUpdatedVariant,
    lastUpdatedState,
    mobile,
    token,
    branchCount,
    cityCount
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchBrandsConnect: fetchBrands,
    fetchModelsConnect: fetchModels,
    fetchYearsConnect: fetchYears,
    fetchVariantsConnect: fetchVariants,
    fetchRegistrationStateConnect: fetchRegistrationState,
    resetSelectionsConnect: resetSelections,
    updateSelectedBrandConnect: updateSelectedBrand,
    updateSelectedModelConnect: updateSelectedModel,
    updateSelectedYearConnect: updateSelectedYear,
    updateSelectedVariantConnect: updateSelectedVariant,
    updateSelectedStateConnect: updateSelectedState,
    resetSpecifiedKeyConnect: resetSpecifiedKey,
    setMobileConnect: setMobile,
    makeLeadConnect: makeLead,
    updateLeadConnect: updateLead,
    fetchAllBranchCountConnect: fetchAllBranchCount
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LegacyForm));
